exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wrapper--fus2j{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n", "", {"version":3,"sources":["/workspace/src/widget/new-event-layouts/shared/location-item/styles.scss"],"names":[],"mappings":"AAAA,gBACE,oBAAA,oBAAA,aACA,QACA,yBAAA,sBAAA,kBAAmB,CAAA","file":"styles.scss","sourcesContent":[".wrapper {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "wrapper--fus2j"
};